<template>
<div id="productModal">   
               <!-- Modal content -->
               <div class="product-modal-content">
                <span class="close">&times;</span>
                <div class="">
                 <div class="row" style="margin: 0">
                  <div class="col-12 col-md-5 form-product-container">
                   <div class="modal-content-wrapper">
                    <img style="width: 100%; margin-top: 40px;" :src="'http://admin.agrobiosol.com.mx:45201/' + product.image">     
                  </div>
                </div>

                <div class="col-12 col-md-7">
                 <div class="modal-content-wrapper">
                  <div style="color: #333; margin-bottom: 40px;" class="section-heading section-heading--white" data-aos="fade">
                   <h2 style="color: #333; font-size: 27px; font-weight: 400;" class="__title"><span style="font-weight: 400;">{{ product.title }}</span></h2>
                 </div>
                 <div class="product-info">

                 </div>
                 <p class="product-info-item"><span>Categoría:</span> {{ product.category }}</p>
                 <p class="product-info-item"><span>Subcategoría:</span> {{ product.subcategory }}</p>
                 <p class="product-info-item"><span>Fabricante:</span> {{ product.manufacturer }}</p>
                 <p class="product-info-item" style="overflow:scroll;height:200px;"><span>Descripción:</span> {{ product.description }}</p>
                 <br>
                 <hr>
                 
                <div style="padding-top:20px;">
                  <a class="product-document" :href="'http://admin.agrobiosol.com.mx:45201/' + product.dataSheet" target="_blank">FICHA TÉCNICA</a> |
                   
                   <a class="product-document" :href="'http://admin.agrobiosol.com.mx:45201/' + product.securitySheet" target="_blank">HOJA DE SEGURIDAD</a>
                </div>


                 <div v-if="!auth" style="padding:20px;">
                   <p style="color:#333;font-size:18px;"><i style="margin-right: 8px;color:red" class="fas fa-exclamation-circle"></i>Para descargar el registro COFEPRIS es necesario 
                    <a 
                      style="color:#43a553;cursor:pointer"
                      @click="showLogin"
                      >iniciar sesión</a></p>
                 </div>
                 
                 <div v-else class="document-link-container">
                   <p>{{ cofepris }}</p>
                   <a 
                    class="product-document" 
                    :href="'http://admin.agrobiosol.com.mx:45201/' + product.cofepris" 
                    target="_blank"
                    v-if="cofepris">REGISTRO COFEPRIS</a> <span v-if="cofepris"> | </span> 

                 </div>

               </div>
             </div>             
           </div>
         </div>
       </div>
     </div>
</template>

<script>
export default {
  props: ['product'],
  computed: {
    auth () {
      return this.$store.getters.isAuthenticated
    },
    cofepris () {
      if ('cofepris' in this.product) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    showLogin () {
      // this.showModal = true
      // this.showQuote = false
      console.log('Login Modal')
      this.$store.commit('show')
    }
  }
};
</script>

<style scoped>
/* The Modal (background) */
  #productModal {

    position: fixed; /* Stay in place */
    z-index: 3 !important; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.5); /* Black w/ opacity */
    transition: opacity .3s ease;
  }
  
  /* Modal Content/Box */
  .product-modal-content {
    background-color: #fefefe;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin: 5% auto;
    /*margin-top: 15%;*/
    /*padding: 20px;*/
    /*border: 1px solid #888;*/
    width: 80%; /* Could be more or less, depending on screen size */
  }

  .modal-content-wrapper {
    padding: 30px;
  }

  .form-product-container {
    /*background-color: rgba(0,0,0,0.4);*/
    padding: 0 !important;
  }

  /* The Close Button */
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    display: none;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }

  .product-info {
    font-size: 20rem;
  }

  .document-link-container {
    padding: 20px 0;
  }

  .product-info-item {
    padding: 8px 0;
    font-size: 18px;
  }

  .product-info-item span{
    font-weight: bold;
  }

  .product-document {
    color: #43a553;
    cursor: pointer;
    text-decoration: underline;
  }

</style>